<script setup lang="ts">

import Picture from './Picture.vue';

const props = defineProps<{
    link: boolean,
    href: string,
    title: string,
    text: string,
    street?: string,
    zip?: string,
    place?: string,
    googlemapsurl?: string,
    applemapsurl?: string,
    img: string,
    logo: string,
    features: array,
    partof: string,
}>();

</script>

<template>
    <article class="teaser">
        <div class="overlay-icon" v-if="props.partof == 'Tag des Bades'"></div>
        <div class="thumb">
            <Picture 
                :href="props.href"
                :src="props.img" 
                width="268"
                height="178"
                action="tf"
            />
        </div>
        <div class="logo">
            <Picture 
                :href="props.href"
                :src="props.logo" 
                width="800"
                height="530"
                action="t"
            />
        </div>
        <div class="content">
            <h3>
                <a :href="props.href" v-if="link">
                    {{ title }}
                </a>
                <template v-else>{{ title }}</template>
            </h3>
            <p>{{ text }}</p>
            <p v-if="props.street || props.place">
                {{ street }}<br />
                {{ zip }} {{ place }}
            </p>
        </div>
    </article>
    <div class="buttons">
        <a class="button more-info" :href="href" v-if="link">Mehr Informationen</a>
    </div>
    <div class="buttons">
        <a class="button google-maps" :href="props.googlemapsurl" target="_blank">Google Maps</a>
        <a class="button apple-maps" :href="props.applemapsurl" target="_blank">Apple Maps</a>
    </div>
    <ul class="features">
        <li v-for="feature in props.features" :class="'feature icon ' + feature.class"><span>{{ feature.name }}</span></li>
    </ul>
</template>
